(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-qgc-faq]').forEach(content => {
      if (content.dataset.qgcFaqReady) return;
      content.dataset.qgcFaqReady = 'true';
      let answer = null;
      Array.from(content.children).forEach(node => {
        const question = node.matches('p') ? node.querySelector('strong') : null;
        if (question && /^Q:\s*/i.test(question.textContent.trim())) {
          const details = document.createElement('details'); details.className = 'qgc-faq-item';
          const summary = document.createElement('summary'); summary.textContent = question.textContent.trim().replace(/^Q:\s*/i, '');
          const body = document.createElement('div'); question.remove();
          node.querySelector('br')?.remove();
          node.before(details); details.append(summary, body); body.append(node); answer = body;
        } else if (node.matches('h2,hr')) { answer = null; }
        else if (answer && node.matches('p,ul,ol')) answer.append(node);
      });
    });
    scope.querySelectorAll('[data-qgc-toc]').forEach(nav => {
      const container = nav.closest('.qgc-document-layout,.qgc-article-layout');
      const content = container?.querySelector('[data-qgc-document]');
      if (!content || nav.dataset.qgcTocReady) return;
      nav.dataset.qgcTocReady = 'true';
      const headings = content.querySelectorAll('h2').length ? content.querySelectorAll('h2') : content.querySelectorAll('h3');
      Array.from(headings).forEach((heading, i) => {
        if (!heading.textContent.trim()) return;
        if (!heading.id) heading.id = `qgc-reading-${container.closest('.shopify-section')?.id || 'page'}-${i + 1}`;
        const link = document.createElement('a'); link.href = `#${heading.id}`; link.textContent = heading.textContent.trim(); nav.append(link);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
